export default __webpack_public_path__ + "static/media/logo_ata.df69ab0f.png";